import React from "react";
import { Checkbox, Chip, FormHelperText, InputLabel, FormControl } from "@material-ui/core";
import colors from "../constants/colors";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import { borderColors } from "./EventCard";

export interface CheckBoxSelectorProps {
	//Label of the filter.
	label: string;
	//filters to be shown on in dropdown.
	filters: any[];
	//the starting selected filters.
	selectedFilters: any[];
	//Error message to be shown when invalid input is pased back to filter container.
	errorMessage?: string;
	//Call back method to be dealt with in filter container.
	onFilterChange: (Types: any[]) => void;
	//Dictionary to map values to display names
	filterNames: Record<any, string>;
}

/**
 * This component is a dropdown menu that will contain filters that can be multiselected and will return a list of strings when updated.
 * @param props
 */
export const CheckBoxSelector = (props: CheckBoxSelectorProps) => {
	const [fullList] = React.useState(props.filters);

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		props.onFilterChange(event.target.value as any[]);
	};

	const ITEM_HEIGHT = 30;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 20 + ITEM_PADDING_TOP,
			},
		},
	};

	return (
		<FormControl style={{ marginTop: "10px" }}>
			<InputLabel data-testid="checkbox-label" htmlFor={props.label}>
				{props.label}:
			</InputLabel>
			<Select
				multiple
				value={props.selectedFilters}
				onChange={handleChange}
				data-testid="checkbox-selector"
				input={<Input id="select-multiple-checkbox" />}
				renderValue={(selected) => (
					<div style={{ display: "flex", flexWrap: "wrap" }}>
						{(selected as string[]).map((value) => (
							<Chip
								size="small"
								style={{
									backgroundColor: colors.white,
									borderColor: value in borderColors ? borderColors[value] : colors.gray300,
									borderStyle: "solid",
									marginRight: 5,
									marginBottom: 1,
								}}
								key={value}
								label={props.filterNames[value]}
							/>
						))}
					</div>
				)}
				MenuProps={MenuProps}
			>
				{fullList.map((name) => (
					<MenuItem key={name} value={name} style={{ backgroundColor: colors.white }}>
						<Checkbox style={{ color: borderColors[name] }} checked={props.selectedFilters.indexOf(name) > -1} />
						<ListItemText primary={props.filterNames[name]} />
					</MenuItem>
				))}
			</Select>
			<FormHelperText data-testid="checkbox-errorMessage">{props.errorMessage}</FormHelperText>
		</FormControl>
	);
};
